import { AfterViewInit, Component, ElementRef, Inject, QueryList, ViewChildren } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { GetExistingLeadsGQL } from "../../../../generated/graphql";
import { SnackBarService } from "../../service/snack.bar.service";
import { ProjectService } from "../../../shared/service/project.service";
import { KeyValue } from "@angular/common";
import { PurchaserDialog } from "../purchaser-dialog/purchaser-dialog";

export interface DialogData {
  eLaunchId: string,
  recipientList: []
}

enum LeadStatusEnum {
  ALL = "All Leads Status",
  OPEN = "Open",
  WAITING_LIST = "Waiting List",
  HOT = "Hot",
  COLD = "Cold",
  CONVERTED = "Converted",
  DROP = "Dropped",
}
@Component({
  selector: "lead-contact-dialog",
  templateUrl: "lead-contact-dialog.html",
  styleUrls: ["./lead-contact-dialog.css"]
})


export class LeadContactDialog implements AfterViewInit {
  contactList: any;
  value: any;
  selected: any = [];
  leads: any = [];
  leadList: any = [];
  eLaunchId: string;
  isChecked: boolean = false;
  projectId: string;
  LeadStatus = LeadStatusEnum;
  all: any;
  open: any;
  hot: any;
  cold: any;
  drop: any;
  waitingList: any;
  converted: any;
  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }
  salesPersonList: any = [];
  selectedStatus: string = LeadStatusEnum.ALL;
  selectedSalesPerson = { sales_person_name: "All Sales Staff", sales_person_id: "All Sales Staff" };
  displayList: any = [];

  limit: number = 15;
  currentPage: number = 1;
  observer: any;
  @ViewChildren("theLast", { read: ElementRef }) theLast: QueryList<ElementRef>;

  constructor(
    private snackBarService: SnackBarService,
    private projectService: ProjectService,
    private getExistingLeadsGQL: GetExistingLeadsGQL,
    public dialogRef: MatDialogRef<LeadContactDialog>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {
    this.eLaunchId = this.data?.eLaunchId;

    this.projectService.Current$.subscribe(
      () => (
        (this.projectId = this.projectService.Current)
      )
    );
    this.getExistingLeadList(this.selectedStatus, this.selectedSalesPerson.sales_person_id, ['limit', `${this.limit}`, 'offset', '0']);
    this.infiniteScroller()
  }

  ngAfterViewInit() {
    this.theLast.changes.subscribe((d) => {
      if (d.last) this.observer.observe(d.last.nativeElement);
    })
  }

  private infiniteScroller() {
    let options = {
      root: document.querySelector("#scrollArea"),
      rootMargin: "0px",
      threshold: 0.1,
    };

    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        if (this.currentPage <= Math.ceil(this.leads.total / this.limit)) {
          this.currentPage++;
          this.getExistingLeadList(this.selectedStatus, this.selectedSalesPerson.sales_person_id, ['limit', `${this.limit}`, 'offset', `${(this.limit * this.currentPage) - this.limit}`]);
        }
      }
    }, options);
  }

  private getExistingLeadList(leadStatus, salesPersonStatus, limit) {
    this.selected = [];
    this.isChecked = false;
    this.getExistingLeadsGQL.fetch({
       eLaunchId: this.eLaunchId, 
       projectId: this.projectId, 
       leadStatusFilter: leadStatus,
       salesPersonFilter: salesPersonStatus, 
       limitFilter: limit })
       .subscribe((result) => {
      if (result?.errors) {
        this.snackBarService.showQueryError(result.errors);
      }
      this.contactList = result.data.getExistingLeads;
      this.leads = this.contactList;
      this.leadList =  result.data.getExistingLeads?.data;


      this.all = this.getStatusCount(this.LeadStatus.ALL);
      this.open = this.getStatusCount(this.LeadStatus.OPEN);
      this.waitingList = this.getStatusCount(this.LeadStatus.WAITING_LIST);
      this.hot = this.getStatusCount(this.LeadStatus.HOT);
      this.cold = this.getStatusCount(this.LeadStatus.COLD);
      this.drop = this.getStatusCount(this.LeadStatus.DROP);

      if (!this.salesPersonList.length) {
        this.salesPersonList = [...new Map(this.contactList?.data?.map((x) => [x["sales_person_id"], x])).values()]
        this.salesPersonList.sort((a, b) => (a.sales_person_name > b.sales_person_name) ? 1 : ((b.sales_person_name > a.sales_person_name) ? -1 : 0))
        this.salesPersonList.unshift({ sales_person_name: "All Sales Staff", sales_person_id: "All Sales Staff" })
      }
    })
  }

  private getStatusCount(status): [] {
    return this.leads?.data?.filter((x) => x.lead_status === status);
  }

  selectAll(event) {
    if (event?.checked) {
      if (this.value)
        this.selected = this.contactList?.data.filter((x => JSON.stringify(x).toLowerCase().
          includes(this.value.toLowerCase())));
      else {
        this.selected = this.contactList?.data
      }
    }
    else {
      this.selected = [];
    }
  }

  contentDialog(contactId?: string, sUserId?: string) {
    event.stopPropagation();
    this.dialog.open(PurchaserDialog, {
      panelClass: "ng-dialog-container",
      data: {
        contactId: contactId,
        sUserId: sUserId,
      },
    });
  }

  submit() {

    if (!this.selected?.length)
      return this.snackBarService.show("Please select atleast one lead before submit");

    this.dialogRef.close({
      leads: this.selected?.map(x => x)
    }
    );
  }

}
